import React from 'react'
import styled from '@emotion/styled'
import {Link} from 'react-router-dom'

const Root = styled(Link)`
  border: none;
  text-decoration: none;
  color: inherit;
`

const GoodLink = ({
  goodId,
  activeCatalogType = null,
  activeCategory = null,
  children
}) => {
  const pathname = `/app/catalog/good/${goodId}`
  let search = null
  if (activeCatalogType) {
    search = `from=${activeCatalogType.name}`
    if (activeCategory) search += `-${activeCategory.id}`
  }

  return <Root to={{pathname, search, state: {canGoBack: true}}}>
    {children}
  </Root>
}

export default GoodLink
